import { useState } from "react";
import { BottomDrawer } from "../../../../components/ui/BottomDrawer";
import { IncludeExcludeProvidersGamesDetails } from "../../models/responses/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Button } from "../../../../components/ui";
import { BonusConsts } from "../../models/constants/bonusConsts";
import localization from "../../../../config/localization";

interface ProviderGamesDrawerProps {
  open: boolean;
  onClose: () => void;
  details: IncludeExcludeProvidersGamesDetails[];
}

function ProviderAccordion({
  provider,
  activeTab,
}: {
  provider: IncludeExcludeProvidersGamesDetails;
  activeTab: string | null;
}) {
  const [expanded, setExpanded] = useState(false);

  const games = provider.Game
    ? provider.Game.split(",")
      .map((g) => g.trim())
      .filter(Boolean)
    : [];

  return (
    <div className="border border-[#353535] rounded">
      <Button
        className="flex justify-between items-center w-full px-4 py-3 text-[#E6E6E6] text-sm"
        onClick={() => setExpanded(!expanded)}
      >
        <span>{provider.ProviderSupplierList}</span>
        <FontAwesomeIcon
          icon={expanded ? faChevronUp : faChevronDown}
          className="text-[#E6E6E6] text-sm"
        />
      </Button>
      {expanded && (
        <div className="px-4 pb-3">
          {games.length > 0 ? (
            games.map((game, i) => (
              <p key={i} className="text-white text-sm py-0.5">
                • {game}
              </p>
            ))
          ) : (
            <p className="text-[#A9A9A9] text-sm">
              {activeTab === "include"
                ? localization.all_provider_games_included
                : localization.all_provider_games_excluded}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default function ProviderGamesDrawer({
  open,
  onClose,
  details,
}: ProviderGamesDrawerProps) {
  const [activeTab, setActiveTab] = useState<string | null>("include");
  const includedProviders = details.filter(
    (d) => d.Category === BonusConsts.Include,
  );
  const excludedProviders = details.filter(
    (d) => d.Category === BonusConsts.Exclude,
  );
  const currentList =
    activeTab === "include" ? includedProviders : excludedProviders;

  return (
    <BottomDrawer
      open={open}
      onClose={onClose}
      className="w-full lg:max-w-[80%] lg:mx-auto"
    >
      <h2 className="text-white text-lg font-semibold mb-4">
        <span>{localization.provider_and_games}</span>
      </h2>

      <div className="flex border-b border-[#353535] mb-4">
        <Button
          className={`flex-1 pb-2 text-sm font-medium ${activeTab === "include"
              ? "text-white border-b-2 border-[#FF94B1]"
              : "text-[#A9A9A9]"
            }`}
          onClick={() => setActiveTab("include")}
        >
          <span>{localization.included}</span>
        </Button>
        <Button
          className={`flex-1 pb-2 text-sm font-medium ${activeTab === "exclude"
              ? "text-white border-b-2 border-[#FF94B1]"
              : "text-[#A9A9A9]"
            }`}
          onClick={() => setActiveTab("exclude")}
        >
          <span>{localization.excluded}</span>
        </Button>
      </div>

      {currentList.length > 0 ? (
        <div className="grid gap-2">
          {currentList.map((provider, index) => (
            <ProviderAccordion
              key={`${activeTab}-${index}`}
              provider={provider}
              activeTab={activeTab}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-10">
          <img src="/icons/Bonus/ic-no-games-found.svg" alt="No Games Found" />
          <span className="text-sm text-[#FF7393]">
            {localization.no_games_found}
          </span>
        </div>
      )}
    </BottomDrawer>
  );
}
